import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Provider } from 'jotai';
import { HashRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Routes } from './Routes';
import { Layout } from './Layout';
import { AtomWatchers } from './atoms';
import { ApolloProvider, ERC20Provider, I18nProvider, MBoxContractProvider, NFTContractProvider, RSS3Provider, ThemeProvider, UploadProvider, Web3Provider, } from './contexts';
import 'react-loading-skeleton/dist/skeleton.css';
import './base.less';
import './variables.less';
import './theme.module.less';
import styles from './app.module.less';
console.log(`%cMaskBox interface.\nversion: ${process.env.VERSION}`, 'background: #0057ff;color: #ffffff;');
function App() {
    return (_jsx(Router, { children: _jsx(ThemeProvider, { children: _jsx(Provider, { children: _jsx(I18nProvider, { children: _jsxs(UploadProvider, { children: [_jsx(Web3Provider, { children: _jsx(AtomWatchers, { children: _jsx(ERC20Provider, { children: _jsx(ApolloProvider, { children: _jsx(NFTContractProvider, { children: _jsx(MBoxContractProvider, { children: _jsx(RSS3Provider, { children: _jsx(Layout, { children: _jsx(Routes, {}) }) }) }) }) }) }) }) }), _jsx(Toaster, { position: "top-right", containerClassName: styles.toastContainer, toastOptions: {
                                    className: styles.toast,
                                } })] }) }) }) }) }));
}
export default App;
